'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Explorer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _tree = require('antd/lib/tree');

var _tree2 = _interopRequireDefault(_tree);

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _alert = require('antd/lib/alert');

var _alert2 = _interopRequireDefault(_alert);

var _spin = require('antd/lib/spin');

var _spin2 = _interopRequireDefault(_spin);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Explorer = exports.Explorer = (_temp = _class = function (_React$PureComponent) {
  _inherits(Explorer, _React$PureComponent);

  function Explorer(props, context) {
    _classCallCheck(this, Explorer);

    var _this = _possibleConstructorReturn(this, (Explorer.__proto__ || Object.getPrototypeOf(Explorer)).call(this, props, context));

    _this.state = {
      searchValue: '',
      expandedKeys: [],
      activeTab: props.cateId,
      activeKey: props.value,
      dataSource: props.changeNodes ? _this.handleChange(props.dataSource, props.changeNodes) : props.dataSource
    };
    if (props.value) {
      _this.state.expandedKeys = _this.getExpandedKeys(_this.getData(), function (item) {
        return item.id === props.value;
      });
    }

    _this._lazySearch = null;
    return _this;
  }

  /**
   * dataSource = [
   *  {
   *    id,
   *    children
   *  },
   *  ...
   * ]
   */


  _createClass(Explorer, [{
    key: 'handleChange',
    value: function handleChange(dataSource, changeNodes, map) {
      var _this2 = this;

      if (!changeNodes.length) return dataSource;

      if (!map) {
        map = {};
        changeNodes.forEach(function (node, index) {
          map[node.id] = index;
        });
      }

      var newDataSource = [];
      dataSource.forEach(function (item) {
        if (map[item.id] === undefined) {
          if (item.children) {
            item.children = _this2.handleChange(item.children, changeNodes, map);
          }
        } else {
          changeNodes.splice(map[item.id], 1);
          newDataSource.push(item);
        }
      });
      return newDataSource;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataSource !== this.props.dataSource || nextProps.changeNodes !== this.props.changeNodes) {
        this.setState({
          dataSource: this.handleChange(nextProps.dataSource, nextProps.changeNodes)
        });
      }
    }
  }, {
    key: 'getExpandedKeys',
    value: function getExpandedKeys(dataSource, matcher, parentKey) {
      var _this3 = this;

      var expandedKeys = [];
      dataSource.forEach(function (item) {
        if (matcher(item)) {
          // 因为有子集有命中的，所以父级ID要加进去
          if (parentKey) {
            expandedKeys.push(String(parentKey));
            parentKey = null;
          }
          expandedKeys.push(String(item.id));
        } else if (item.children && item.children.length) {
          var keys = _this3.getExpandedKeys(item.children, matcher, item.id);
          var len = keys.length;
          if (len) {
            if (item.id !== keys[len - 1]) {
              expandedKeys.push(String(item.id));
            }
            for (var i = 0; i < len; i++) {
              expandedKeys.push(String(keys[i]));
            }
          }
        }
      });
      return expandedKeys;
    }
  }, {
    key: 'getIcon',
    value: function getIcon(item) {
      var icon = item.icon ? _react2.default.createElement(_icon2.default, { type: item.icon }) : null;
      if (this.props.leafIcon) {
        return icon || (item.children ? null : _react2.default.createElement(_icon2.default, { type: this.props.leafIcon }));
      } else {
        return icon;
      }
    }
  }, {
    key: 'loopTreeNode',
    value: function loopTreeNode(dataSource) {
      var _this4 = this;

      var searchValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var actions = this.props.actions;
      var activeKey = this.state.activeKey;
      var firstMatchId = void 0;
      /**
       * item = {
       *  id,
       *  name,
       *  icon,
       *  children
       * }
       */
      var nodes = dataSource.map(function (item) {
        var index = -1;
        var beforeStr = void 0;
        var afterStr = void 0;
        var title = void 0;
        var label = item.name;
        if (item.title) {
          label = item.title;
        } else if (searchValue) {
          index = label.indexOf(searchValue);
          beforeStr = label.substr(0, index);
          afterStr = label.substr(index + searchValue.length);
        }
        /**
         * actions = [{
         *  icon,
         *  title,
         *  text,
         *  onAction
         * }, ...]
         */
        var btns = null;
        if (actions && (_this4.props.byLeaf && !item.children || !_this4.props.byLeaf)) {
          btns = _react2.default.createElement(
            'span',
            { className: 'o-com-explorer_elem-btns' },
            actions.map(function (btnItem, key) {
              return _react2.default.createElement(
                'a',
                {
                  key: key,
                  href: 'javascript:;',
                  onClick: function onClick() {
                    btnItem.onAction && btnItem.onAction(item);
                  },
                  title: btnItem.title || btnItem.text
                },
                btnItem.icon ? _react2.default.createElement(_icon2.default, { type: btnItem.icon }) : btnItem.text
              );
            })
          );
        }

        if (index > -1) {
          if (!firstMatchId) {
            firstMatchId = item.id;
          }
          title = _react2.default.createElement(
            'span',
            { id: item.id, className: 'o-com-explorer-elem_span' },
            btns,
            _react2.default.createElement(
              'span',
              { onClick: function onClick() {
                  return _this4.handleSelect(item);
                } },
              _this4.getIcon(item),
              beforeStr,
              _react2.default.createElement(
                'span',
                { style: { color: '#f50' } },
                searchValue
              ),
              afterStr
            )
          );
        } else {
          title = _react2.default.createElement(
            'span',
            { id: item.id },
            btns,
            _react2.default.createElement(
              'span',
              { onClick: function onClick() {
                  return _this4.handleSelect(item);
                } },
              _this4.getIcon(item),
              label
            )
          );
        }
        if (item.children && item.children.length) {
          return _react2.default.createElement(
            _tree2.default.TreeNode,
            { key: item.id, title: title, className: activeKey === item.id ? 'active' : '' },
            _this4.loopTreeNode(item.children, searchValue)
          );
        } else {
          return _react2.default.createElement(_tree2.default.TreeNode, { key: item.id, title: title, className: activeKey === item.id ? 'active' : '' });
        }
      });
      if (firstMatchId && this._lazySearch) {
        this._lazySearch(firstMatchId);
        this._lazySearch = null;
      }
      return nodes;
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(node) {
      this.props.onSelect && this.props.onSelect(node);
      this.setState({
        expandedKeys: this.getExpandedKeys(this.getData(), function (item) {
          return node.id === item.id;
        }),
        activeKey: node.id
      });
    }
  }, {
    key: 'getData',
    value: function getData() {
      if (this.props.mode === 'multiple') {
        return this.state.dataSource[this.state.activeTab || 0];
      } else {
        return this.state.dataSource;
      }
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs(dataSource) {
      var _this5 = this;

      var activeTab = this.state.activeTab;

      return _react2.default.createElement(
        'div',
        { className: 'o-com-explorer-elem_btn-group' },
        _react2.default.createElement(
          _radio2.default.Group,
          { value: activeTab, onChange: function onChange(e) {
              _this5.setState({
                searchValue: '',
                expandedKeys: [],
                activeTab: e.target.value
              });
              _this5.props.onChange && _this5.props.onChange(e.target.value);
            } },
          dataSource.map(function (item) {
            return _react2.default.createElement(
              _radio2.default.Button,
              { value: item.id, key: item.id },
              item.name
            );
          })
        )
      );
    }
  }, {
    key: 'renderSearch',
    value: function renderSearch(dataSource) {
      var _this6 = this;

      var searchProps = {
        size: 'small',
        value: this.state.searchValue,
        placeholder: this.props.searchPlaceholder,
        onChange: function onChange(e) {
          var value = e.target.value;
          _this6.setState({
            searchValue: value
          });
          _this6.props.onSearch && _this6.props.onSearch(value);

          clearTimeout(_this6._timer);
          _this6._timer = setTimeout(function () {
            var expandedKeys = _this6.getExpandedKeys(dataSource, function (item) {
              return item.name.indexOf(value) > -1;
            });
            _this6.setState({
              expandedKeys: expandedKeys
            }, function () {
              _this6._lazySearch = function (firstMatchId) {
                _this6._timer = setTimeout(function () {
                  var node = document.getElementById(firstMatchId).parentNode.parentNode.parentNode;
                  node.scrollIntoView();
                }, 200);
              };
            });
          }, 200);
        }
      };
      return _react2.default.createElement(
        'div',
        { className: 'o-com-explorer-elem_search' },
        _react2.default.createElement(_input2.default.Search, searchProps)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props = this.props,
          menu = _props.menu,
          noSearch = _props.noSearch,
          title = _props.title,
          mode = _props.mode;
      var _state = this.state,
          searchValue = _state.searchValue,
          activeKey = _state.activeKey,
          expandedKeys = _state.expandedKeys;

      var dataSource = this.getData();

      var treeProps = {
        checkStrictly: true,
        expandedKeys: expandedKeys,
        autoExpandParent: searchValue !== undefined,
        onExpand: function onExpand(expandedKeys) {
          _this7.setState({
            expandedKeys: expandedKeys,
            searchValue: ''
          });
        },
        multiple: false,
        selectable: false,
        selectedKeys: activeKey ? [String(activeKey)] : [],
        showLine: this.props.showLine
      };
      return _react2.default.createElement(
        'div',
        { className: 'o-com-explorer' },
        _react2.default.createElement(
          'div',
          { className: 'o-com-explorer_wrapper' },
          title ? _react2.default.createElement(
            'div',
            { className: 'o-com-explorer_title' },
            _react2.default.createElement(
              'span',
              { className: 'o-com-explorer_link' },
              title
            ),
            menu
          ) : null,
          mode === 'multiple' ? this.renderTabs(dataSource) : null,
          noSearch ? null : this.renderSearch(dataSource),
          _react2.default.createElement(
            'div',
            { className: 'o-com-explorer_tree' },
            dataSource.length ? _react2.default.createElement(
              _tree2.default,
              treeProps,
              this.loopTreeNode(dataSource, searchValue)
            ) : _react2.default.createElement(
              _spin2.default,
              { spinning: this.props.pending },
              _react2.default.createElement(_alert2.default, { style: { margin: '0 6px' }, message: this.props.pending ? 'Loading...' : this.props.noResult, type: 'warning' })
            )
          )
        )
      );
    }
  }]);

  return Explorer;
}(_react2.default.PureComponent), _class.propTypes = {
  mode: _propTypes2.default.string,
  dataSource: _propTypes2.default.array,
  changeNodes: _propTypes2.default.array,
  noSearch: _propTypes2.default.bool,
  cateId: _propTypes2.default.any,
  value: _propTypes2.default.any,
  onSelect: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  searchPlaceholder: _propTypes2.default.string,
  menu: _propTypes2.default.element,
  title: _propTypes2.default.string,
  actions: _propTypes2.default.array,
  onSearch: _propTypes2.default.func,
  noResult: _propTypes2.default.string,
  pending: _propTypes2.default.bool,
  showLine: _propTypes2.default.bool,
  leafIcon: _propTypes2.default.string,
  byLeaf: _propTypes2.default.bool }, _class.defaultProps = {
  dataSource: [],
  changeNodes: [],
  // single, multiple
  mode: 'single',
  noResult: 'No Result!',
  pending: false
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/explorer/index.jsx
// module id = 83
// module chunks = 0